<section class="attachment-type-list" *appHasPermission="attachmentTypePermissions.MODULE">
  <div class="attachment-type-list__header">
    <app-breadcrumb [home]="home" [items]="breadcrumbs"></app-breadcrumb>
    <div class="attachment-type-list__header__map d-none">
      <i class="pi pi-map"></i>
    </div>
  </div>
  <div class="attachment-type-list__header">
    <div class="attachment-type-list__header__title">
      <h1 class="mb-0 mb-md-2">{{ tk.Management.AttachmentTypes | t }}</h1>
    </div>
    <div class="attachment-type-list__header__search">
      <div class="form-search me-3 d-none d-md-flex">
        <app-search
          [isLoading]="isLoading"
          [placeholder]="(tk.General.Search | t) || ''"
          (sendSearch)="handleSearch($event)"></app-search>
      </div>
      <ng-container *appHasPermission="attachmentTypePermissions.CREATE">
        <app-button
          *ngIf="attachmentTypes.length"
          [id]="'add-group'"
          [label]="isMobile ? '' : (tk.User.ToAdd | t)"
          [icon]="'pi pi-plus'"
          [type]="'button'"
          (sendButtonClick)="addAttachmentType()"></app-button>
      </ng-container>
    </div>
  </div>
  <div class="attachment-type-list__content">
    <app-attachment-type-list-content
      [groupList]="attachmentTypes"
      [pagination]="pagination"
      [loading]="loading"
      (sendTablePagination)="handleTablePagination($event)"
      (sendTableAction)="handleTableAction($event)"></app-attachment-type-list-content>
  </div>
</section>
